import React, {useState} from "react";
import "../EMLOffersChecker/eml-offers-checker.scss";

const EMLApprovedANExport = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleExport = async () => {
        const loggedUserEmail = localStorage.getItem("email");

        if (!loggedUserEmail) {
            setError("User email not found.");
            return;
        }

        setLoading(true);
        setError("");
        setSuccessMessage("");

        try {
            const localToken = localStorage.getItem("auth_token");
            const response = await fetch(
                `${localStorage.getItem("apiUrl")}api/an-setups/export-approved`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localToken}`,
                    },
                    body: JSON.stringify({email: loggedUserEmail}),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setSuccessMessage(data.message || "Export request sent. Check your email.");
        } catch (err) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="eml-offers-checker">
            <div className="upload-card">
                <div className="upload-card__header">
                    <div>
                        <p className="upload-title">Export Approved AN Setups for EML</p>
                    </div>
                </div>

                {error ? <p className="upload-error">{error}</p> : null}
                {successMessage ? (
                    <p className="upload-success">{successMessage}</p>
                ) : null}

                <button
                    className="blue-btn upload-submit"
                    disabled={loading}
                    onClick={handleExport}
                >
                    {loading ? "Processing..." : "Export approved AN setups"}
                </button>
            </div>
        </div>
    );
};

export default EMLApprovedANExport;
